import { Router, Wifi } from "lucide-react";
import { rp } from "@/lib/api";
import { VoucherQr } from "@/components/VoucherQr";
import { fmtDur } from "@/pages/admin/PrintVouchers";

/** Kartu voucher siap cetak — harga asli (harga user) besar + durasi, tanpa nama paket. */
export const VoucherCard = ({ v, wifi = "ALPHANET", cs = "", note = "", loginUrl = "", price = null }) => (
  <div className="overflow-hidden rounded-xl border border-violet-500/40 bg-card print:border-black">
    <div className="flex items-center justify-between bg-gradient-to-r from-cyan-500/20 to-violet-600/25 px-3 py-2">
      <div className="flex items-center gap-1.5">
        <Wifi className="h-3.5 w-3.5 text-cyan-400" />
        <span className="font-display text-[11px] font-semibold tracking-wide">{wifi}</span>
      </div>
      <span className="font-mono text-[9px] uppercase tracking-[0.15em] text-muted-foreground">ALPHA BILL</span>
    </div>
    <div className="px-3 py-3 text-center">
      <p className="text-[9px] uppercase tracking-[0.2em] text-muted-foreground">Kode Voucher</p>
      <p className="mt-1 font-mono text-lg font-bold tracking-[0.15em]">{v.username}</p>
      <p className="font-mono text-[10px] text-muted-foreground">user = password</p>
      <div className="mt-2 flex items-center justify-center">
        <div className="rounded bg-white p-1"><VoucherQr v={v} loginUrl={loginUrl} size={56} /></div>
      </div>
      <p className="mt-1 text-[8px] text-muted-foreground">Scan QR untuk login cepat</p>
      <p className="mt-2 text-2xl font-black leading-none tracking-tight print:text-black" data-testid={`card-price-${v.username}`}>
        {rp(price ?? v.price)}
      </p>
      {fmtDur(v.limit_uptime || "") ? (
        <p className="mt-0.5 text-[10px] font-semibold text-muted-foreground">{fmtDur(v.limit_uptime)}</p>
      ) : null}
    </div>
    <div className="border-t border-dashed border-border px-3 py-2">
      <p className="text-[8px] leading-relaxed text-muted-foreground">
        {note || "Sambungkan ke WiFi, buka browser, masukkan kode di halaman login."}
      </p>
      {cs ? (
        <p className="mt-1 flex items-center gap-1 font-mono text-[8px] text-muted-foreground">
          <Router className="h-2.5 w-2.5" /> CS/WA: {cs}
        </p>
      ) : null}
    </div>
  </div>
);
